import React from "react";
import { Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import HomePage from "./pages/HomePage";

import Security from "./pages/Security";
import Network from "./pages/Network";
import ITInfrastructure from "./pages/ITInfrastructure";
import GeneralOrderSupply from "./pages/GeneralOrderSupply";
import ServicesPage from "./pages/ServicesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ResourcesPage from "./pages/ResourcesPage";
import ResourceDetail from "./pages/ResourceDetail";
import NewsletterPage from "./pages/NewsletterPage";
import LegalPage from "./pages/LegalPage";

import "./App.css";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/resources/:type/:id" element={<ResourceDetail />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/newsletter" element={<NewsletterPage />} />
        <Route path="/privacy" element={<LegalPage type="privacy" />} />
        <Route path="/terms" element={<LegalPage type="terms" />} />
        <Route path="/cookies" element={<LegalPage type="cookies" />} />
        <Route path="/security" element={<Security />} />
        <Route path="/network" element={<Network />} />
        <Route path="/it-infrastructure" element={<ITInfrastructure />} />
        <Route path="/general-order-supply" element={<GeneralOrderSupply />} />
      </Routes>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default App;